// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    securitylog_msg_LoginChanged: 'Login cambiata dall\'utente {0}.',
    securitylog_msg_LoginChangedBySelf: 'Login cambiata.',
    securitylog_msg_PasswordChanged: 'Password cambiata dall\'utente {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Password recuperata.',
    securitylog_msg_PasswordChangedBySelf: 'Password cambiata.',
    securitylog_msg_PasswordIncorrect: 'Password non corretta.',
    securitylog_msg_RecoveryRequest: 'Recupero necessario.',
    securitylog_msg_UserLockout: 'L\'utente è stato bloccato a causa di tentativi di inserimento di Password non valide.',
    securitylog_msg_UserLockoutDueToInactivity: 'L\'utente è stato bloccato a causa di inattività.',
};
